module.exports = __webpack_public_path__ + "img/orbita.72e60b43.png";